import React from 'react';
import { Box, darken, SxProps, Typography, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';

export type LinkButtonProps = {
    to: string;
    onClick: () => void;
    label: string;
    target?: React.HTMLAttributeAnchorTarget;
    textSx?: SxProps;
    wrapperSx?: SxProps;
};
const LinkButton: React.FunctionComponent<LinkButtonProps> = function ({
    to,
    onClick = () => {},
    label,
    textSx,
    wrapperSx,
    target = '_self',
}) {
    const { palette } = useTheme();

    return (
        <Link
            to={to}
            onClick={onClick}
            style={{ textDecoration: 'none' }}
            data-testid="LinkButton"
            target={target}
        >
            <Box
                sx={{
                    padding: '16px 24px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: palette.primary.contrastText,
                    borderRadius: '6px',
                    backgroundColor: palette.primary.dark,
                    transition: 'all 0.2s ease-in-out',
                    '&:hover': {
                        backgroundColor: darken(palette.primary.dark, 0.1),
                    },
                    ...wrapperSx,
                }}
            >
                <Typography sx={textSx}>{label}</Typography>
            </Box>
        </Link>
    );
};

export default LinkButton;
